var ytPlayer;
var video;

$(function(){
	//商品一覧　Pickup Layout
	if($("#Products").length){
		var container = $("#Products ul.threecolumn");
		var columGroupNum = 18;
		var listMaxNum = $("#Products ul.threecolumn li").length;
		var ProductsList = $("#Products ul.threecolumn li");
		var cue1 = 4;
		var cue2 = 11;
		var loopNum = 1;
		var layout_flg = 1;
		var LayoutSwitchBtn = $("#LayoutSwitcher li");

		LayoutSwitchBtn.on('click',function(e){
			 var index = $('#LayoutSwitcher li').index(this);
			if(index == 0 && layout_flg != 1){
				LayoutSwitcher(1);
			}else if(index == 1 && layout_flg != 2){
				LayoutSwitcher(2);
			}
		});
		//初期設定PickUpLayout;
		LayoutSwitcher(1);
		function LayoutSwitcher(num){
			$(LayoutSwitchBtn).removeClass("active");
			$(LayoutSwitchBtn).eq(num-1).addClass("active");
			if(num == 1){
				loopNum = 1;
				layout_flg = 1;
				 $(container).addClass("grid");
				for(var i = loopNum; i <= listMaxNum; i++){
					if(loopNum == cue1){
						$(ProductsList).eq(i).addClass("large");
					}else if(loopNum == cue2){
						$(ProductsList).eq(i).addClass("large2");
					}
					if(loopNum == columGroupNum){
						loopNum = 1;
					}else{
						loopNum++;
					}
				}
			}else{
				layout_flg = 2;
				$(container).removeClass("grid");
				$(ProductsList).removeClass("large");
				$(ProductsList).removeClass("large2");
			}
		}
		//フィルターサイズ部の1/2表示調整
		if($("#Filter .size").length){
			$("#Filter .size li").each(function(i){
				var tempText = $(this).children("a").text();
				if(tempText.match(" 1/2")){
					var tempArray = tempText.split(" ");
					$(this).children("a").text(tempArray[0]);
					$(this).children("a").append("<span> 1/2</span>");
				}
			});
		}
	}

	//商品詳細
	var FixedBag = $("#FixedBag > .inner");
	var fixedbag_h;
	var head_h;
	var fixedbag_pos;
	var bag_pos;
	var size;
	var size_h;
	var slick;
	/*var tag;
	var firstScriptTag;
	var ytPlayer;
	var VideoId;
	var player;*/
	if($("#ProductDetail").length){
		$("#ProductDetail #VideoThumbnail").on('click',function(){
			 $('#ProductDetail #VideoThumbnail').addClass("hidden");
			 videoControl("playVideo");
		});
		// YouTubeの埋め込み
		var tag = document.createElement('script');
		var target = '#VideoSpace_'+device;
		video = $(target).data('src');
		tag.src = "https://www.youtube.com/iframe_api";
		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

		$("#ProductDetail #Info .othercolors a").on('click',function(){
			 $('#OtherColors').toggleClass("active");
		});
		$("#OtherColors .closebtn").on('click',function(){
			 $('#OtherColors').toggleClass("active");
		});

		if(device=="sp"){
			fixedbag_h = 60;
			head_h = 0;

			/*$('#Images .slick-next').on('click', function () {
				console.log("test", slick);
			slick.slickNext();
			});
			$('#Images .slick-prev').on('click', function () {
			slick.slickPrev();
			});*/
			$("#ProductDetail .swatch-attribute").on('click',function(){
				 //$('#SizeSelect').toggleClass("active");
				 $('.accordion_inner').toggle();
				 $('.accordion_two').toggleClass("open");
			});
			/* $("#SizeSelect .closebtn").on('click',function(){
				 $('#SizeSelect').toggleClass("active");
				 $('body').toggleClass("open-sizeguide");
			});
			$("#SizeSelect #Submitbtn").on('click',function(){
				$('#SizeSelect').toggleClass("active");
				$('body').toggleClass("open-sizeguide");
			});
			$("#SizeSelect .sizes li").on('click',function(){
				$("#SizeSelect .sizes li.selected").removeClass("selected");
				$(this).toggleClass("selected");
				$('#ProductDetail .swatch-attribute-selected-option').text($(this).text());
				$("#ProductDetail #classcategory_id1").val($(this).attr('data-id')).change();
			}); */
		}else{
			fixedbag_h = 120;
			head_h = 80;
			$("#ProductDetail .sizes li").on('click',function(){
				$("#ProductDetail .sizes li.selected").removeClass("selected");
				$(this).toggleClass("selected");
				$("#ProductDetail #classcategory_id1").val($(this).attr('data-id')).change();
			});
		}
		function setProductDetail(){
			size = getScreenSize();
			size_h = size[1] - fixedbag_h + head_h;
			//商品詳細
			fixedbag_pos = $("#FixedBag").offset().top;
			//★エラーが出てたので一時的にミュート
			bag_pos = $("#AddToBag").offset().top;
		}

		/* 商品画像チェックし、ワイド画像は100%表示 */
		$(window).on('load',function() {
			var Images = $('#Images li');
			$.each(Images, function(i, target){
				var target = $(target);
				var target_image = target.find("img");
				var tw = target_image.width();
				var th = target_image.height();
				var ts = tw - th;
				//console.log(ts + "  : "+ device);
				ts = Math.abs( ts );
				if(ts > 0 && device == "pc"){
					target.width("100%");
				}else if(ts > 0 && device == "sp"){
					target.appendTo('#WideImage');
				}
			});

			if(device == "sp"){
				slick = $('#Images ul.slider-ul').slick({
					dots: false,
					arrows: true,
					nextArrow: '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0651/9963/6706/files/ico-right.svg?v=1664365156" alt="→"></div>',
					prevArrow: '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0651/9963/6706/files/ico-left.svg?v=1664365210" alt="→"></div>',
					speed: 300,
					width:"90%"
				});
				$('#Images ul.slider-ul').bind('touchstart', function(){
				return true;
				});

			}else{//PC時
				// メイン画像のオプション
				slick = $('#Images ul.slider-ul').slick({
					dots: false,
					arrows: false,
					speed: 300,
					width:"90%",
					asNavFor: ".thumb-ul"
				});
				// サムネイルのオプション
				$(".thumb-ul").slick({
					slidesToShow: 10, // サムネイルの表示数
					asNavFor: "#Images ul.slider-ul", // メイン画像と同期
					focusOnSelect: true, // サムネイルクリックを有効化
					arrows: true,
					nextArrow: '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0651/9963/6706/files/ico-right.svg?v=1664365156" alt="→"></div>',
					prevArrow: '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0651/9963/6706/files/ico-left.svg?v=1664365210" alt="→"></div>',
				});
			}
		});

		var sizes = $('.sizes li');
		$.each(sizes, function(i, target){
			var target = $(target);
			var str = target.text();
			var result = str.replace( '1/2', '<span>1/2</span>' );
			target.html(result);
		});

		/*var $playerWindow;
		if($('#popup-YouTube-player_'+device).length){
			$playerWindow = $('#popup-YouTube-player_'+device)[0].contentWindow;
		}*/
		/* YouTubeの操作 */
		function videoControl(action){
      //$playerWindow.postMessage('{"event":"command","func":"'+action+'","args":""}', '*');
			if(action == 'playVideo'){
				ytPlayer.playVideo();
			}else if(action == 'stopVideo'){
				ytPlayer.stopVideo();
			}
    	}
	}

	/* 商品詳細アコーディオン */
	//.accordion_oneの中の.accordion_headerがクリックされたら
	$('.accordion_one .accordion_header').click(function(){
		//クリックされた.accordion_oneの中の.accordion_headerに隣接する.accordion_innerが開いたり閉じたりする。
		$(this).next('.accordion_inner').toggle();
		$(this).toggleClass("open");
	});

	/* if(device == "sp"){ */
	/* 関連商品スライダー */
	$(window).on('load',function() {
		$('.other-colors-slick').slick({
			arrows: true,
			slidesToShow: 6,
			nextArrow: '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0651/9963/6706/files/ico-right.svg?v=1664365156" alt="→"></div>',
			prevArrow: '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0651/9963/6706/files/ico-left.svg?v=1664365210" alt="→"></div>',
			//appendArrows: $('.slick-arrows'),
			//centerMode:true,
			responsive: [
				{
					breakpoint: 766, // 768px以下のサイズに適用
					settings: {
					slidesToShow: 4,
					},
				},
			],
		});
	});
/* } */


	var SideGuide = $("#SizeGuide");
		if(SideGuide.length){
		$(".sizeguide").on('click',function(){
			$(SideGuide).toggleClass("active");
			$('body').toggleClass("open-sizeguide");
		});
	}

	var FilterBtn = $("#FilterBtn");
	if(FilterBtn.length){
		$(Filter).insertAfter('#Footer');
		$(Filter).append('<span></span>');
		$(".filter_btn").on('click',function(){
			$(Filter).toggleClass("active");
			$('body').toggleClass("open-filters");
		});
		$("#Filter span").on('click',function(){
			$(Filter).removeClass("active");
			$('body').removeClass("open-filters");
		});
		$("#Filter #Closebtn").on('click',function(){
			$(Filter).removeClass("active");
			$('body').removeClass("open-filters");
		});
		var target = $('#Filter .body');
		$(target).show();
		$(target).toggleClass('active');
		$(target).next(".body").slideToggle(200);
	}

	/*===================================================
							Window
	=====================================================*/

	//ページが読み込まれたら実行1
	$(window).on('load',function() {
		if($(FixedBag).length){
			setProductDetail();
		}
	});

	//ウィンドウリサイズしたら実行
	$(window).on('resize',function() {
		if($(FixedBag).length){
			setProductDetail();
		}
	});

	//スクロールしたら実行
	$(window).on('scroll',function() {
		var ty = $(window).scrollTop();
		//商品詳細
		if(ty > bag_pos && ty < fixedbag_pos - size_h && $(FixedBag).length){
			$(FixedBag).addClass("fixed");
		}else{
			$(FixedBag).removeClass("fixed");
		}

		if($('#ProductDetail #VideoThumbnail').hasClass('hidden')){
			$('#ProductDetail #VideoThumbnail').removeClass("hidden");
			videoControl("stopVideo");
		}
	});

});



function onYouTubeIframeAPIReady() {
	var target = 'VideoSpace_'+device;
	//console.log(video, target);
	ytPlayer = new YT.Player(
		target, // 埋め込む場所の指定
		{
			width: 640, // プレーヤーの幅
			height: 480, // プレーヤーの高さ
			videoId: video, // YouTubeのID
			// パラメータの設定
			playerVars: {
				color: "white",
				controls: 0,
				rel: 0,
				showinfo: 0,
				modestbranding: 1,
				widgetid: 1
			}
		}
	);
}
